// @flow
import React from 'react';

import { t } from 'Src/i18n';
import { AlternativeSuggestionCriteria } from 'Components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeSuggestionCriteria';
import { AlternativeSuggestions } from 'Components/widgets/alternative-proposals/alternative-suggestions/AlternativeSuggestions';

type Props = {|
  arrivalDate: string,
  duration: number,
  dates: $ReadOnlyArray<DateSuggestion>,
  onClose?: () => void,
  onSubmit: (args: *) => void,
  resort: $ReadOnly<{
    name: string,
    image?: string,
  }>,
  showTitle?: boolean,
  categoryGA?: string,
|};

export const AlternativeDateSuggestion = (props: Props) => {
  const { onSubmit, onClose, resort, dates, categoryGA = 'resort' } = props;

  return (
    <AlternativeSuggestions
      title={t('booking.counterProposalPopIn.weSuggestLabel', { resortName: resort.name })}
      onClose={onClose}
      immersiveResort={resort}
    >
      {dates.map(suggestion => {
        return (
          <AlternativeSuggestionCriteria
            key={suggestion.dateOffset}
            suggestion={suggestion}
            onSubmit={onSubmit}
            categoryGA={categoryGA}
            buttonLabel={t('booking.counterProposalPopIn.checkPriceLabel')}
          />
        );
      })}
    </AlternativeSuggestions>
  );
};
